import Axios from "axios";

class RoteiroDataService {
  toEntityReference(entity) {
    return entity && entity.id ? { id: entity.id } : null;
  }

  toCreatePayload(params) {
    return {
      roteiro: params.roteiro,
      dataInicio: params.dataInicio,
      dataTermino: params.dataTermino,
      tipoRoteiro: params.tipoRoteiro || "OUTROS",
      tipoAtendimentoRoteiro: params.tipoAtendimentoRoteiro || "URBANO",
      imobilizado: this.toEntityReference(params.imobilizado),
      operador: this.toEntityReference(params.operador),
    };
  }

  toUpdatePayload(params) {
    return {
      id: params.id,
      roteiro: params.roteiro,
      dataInicio: params.dataInicio,
      dataTermino: params.dataTermino,
      tipoRoteiro: params.tipoRoteiro || "OUTROS",
      tipoAtendimentoRoteiro: params.tipoAtendimentoRoteiro || "URBANO",
      imobilizado: this.toEntityReference(params.imobilizado),
      operador: this.toEntityReference(params.operador),
    };
  }

  findItem(id) {
    return Axios.get(`roteiroTrajetos/${id}`);
  }

  getAll() {
    return Axios.get("roteiros");
  }

  getPage(params) {
    return Axios.get("roteiros/page", { params });
  }

  create(params) {
    return Axios.post("roteiros", this.toCreatePayload(params), {
      headers: { "Content-Type": "application/json" },
    });
  }

  update(params) {
    return Axios.put("roteiros/" + params.id, this.toUpdatePayload(params), {
      headers: { "Content-Type": "application/json" },
    });
  }

  find(id) {
    return Axios.get(`roteiros/${id}`);
  }

  delete(id) {
    return Axios.delete(`roteiros/${id}`);
  }

  getUser() {
    return Axios.get(`usuarios/dados_Usuario/simplified`);
  }
  getRoteiroTrajetoId(id) {
    return Axios.get(`/roteiroTrajetos/roteiroTrajetoId/${id}`);
  }

  createTrajeto(params) {
    return Axios.post("/roteiroTrajetos", params);
  }

  removeTrajeto(id) {
    return Axios.delete(`/roteiroTrajetos/${id}`);
  }

  getPedidos(date) {
    return Axios.get("/pedidosTransporte/pending/" + date);
  }

  getFilter(params) {
    return Axios.post("roteiros/filter", params);
  }

  printFolhaRota(params = {}) {
    return Axios.post("roteiros/print/folha-rota", params, {
      responseType: "blob",
    });
  }

  getEscala(roteiroId) {
    return Axios.get(`roteiros/${roteiroId}/escala`);
  }

  addEscala(roteiroId, params) {
    return Axios.post(`roteiros/${roteiroId}/escala`, params);
  }

  replaceEscala(roteiroId, params) {
    return Axios.put(`roteiros/${roteiroId}/escala`, params);
  }

  removeEscala(roteiroId, escalaId) {
    return Axios.delete(`roteiros/${roteiroId}/escala/${escalaId}`);
  }

  gerarEscalaAutomatica(roteiroId) {
    return Axios.post(`roteiros/${roteiroId}/escala/auto`, {});
  }

  gerarEscalaAutomaticaPorData(data) {
    return Axios.post(`roteiros/escala/auto/data/${data}`, {});
  }

  getFuncionariosEscala(funcao) {
    return Axios.get(`roteiros/escala/funcionarios/${funcao}`);
  }

  getEscalaByRota(rota, data = null) {
    const params = {};
    if (data) {
      params.data = data;
    }
    return Axios.get(`roteiros/escala/rota/${rota}`, { params });
  }
}

export default new RoteiroDataService();
